import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StarComponent } from './star/star.component';
import { FiveStarComponent } from './five-star/five-star.component';

@NgModule({
  declarations: [StarComponent, FiveStarComponent],
  exports: [StarComponent, FiveStarComponent],
  imports: [CommonModule],
})
export class ComponentsModule {}
